import React, { useEffect, useState } from 'react'
import { getCurrentAccount, isCorrectChainId } from 'eth/ethUtils'
import { useDispatch, useSelector } from 'react-redux'
import { setEthAccount } from 'redux/actions/accountActions'
import DisplayUseSepolia from 'components/nft/DisplayUseSepolia'
import { listenForAccountsChange } from 'eth/ethUtils'
import { listenForChainChange } from 'eth/ethUtils'
import DisplayNoWallet from './DisplayNoWallet'
import { getBrandName } from 'util/brandUtils'
import { getDisplayType } from 'redux/actions/displayActions'

export default function CheckForWallet({ label = 'create', render }) {
    const acc = useSelector((state) => state.account)
    const { ethAccount } = acc
    const [correctChainId, setCorrectChainId] = useState(undefined)
    const dispatch = useDispatch()
    const displayWalletOrRender = () => {
        if (!window.ethereum) {
            return <DisplayNoWallet />
        }
        if (!ethAccount) {
            return (
                <div style={{ padding: '1vw' }}>
                    <h4>
                        To {label} a {getBrandName(getDisplayType())} NFT, you must be
                        connected to the Ethereum network
                    </h4>
                    <p>
                        <a href='/Vault'>Click here</a> to connect.
                    </p>
                </div>
            )
        } else if (!correctChainId) {
            return <DisplayUseSepolia />
        } else {
            return render(ethAccount)
        }
    }
    const init = async () => {
        const currentAccount = await getCurrentAccount()
        dispatch(setEthAccount(currentAccount))
        const chainId = await isCorrectChainId()
        setCorrectChainId(chainId)
        if (ethAccount && chainId) {
            listenForAccountsChange()
            listenForChainChange()
        }
    }
    useEffect(() => {
        init()
    }, []) //[ethAccount])
    return correctChainId !== undefined ? displayWalletOrRender() : null
}